import React from 'react'

import { useMixes } from '../../../firebase/hooks/useMixes'

import { CustomMix } from './CustomMix/CustomMix'
import { NewMix } from './NewMix/NewMix'

const CustomMixes = () => {
  const mixes = useMixes()

  return (
    <>
      {mixes.map((m) => (
        <CustomMix key={m.id} mix={m} />
      ))}
      <NewMix />
    </>
  )
}

export { CustomMixes }
